import React, { useEffect } from 'react';
import Lottie from "react-lottie";
import * as about from "./aboutme.json"

function AboutAnimation() {
    const defaultOptions = {
        loop: true,
        autoplay: true, 
        animationData: about.default,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return (
        <div >
        <Lottie options={defaultOptions} height={200} width={200} />
    </div>
    )
}

export default AboutAnimation;
